import { reduxKey } from './constants';
import { EmoteStoreSlice, EmoteStreamType } from './types';

function getState(state: any): Partial<EmoteStoreSlice> {
  if (!state[reduxKey]) {
    return {};
  }
  return state[reduxKey];
}

export const getActiveStreamType = (state): EmoteStreamType =>
  getState(state).activeStream || EmoteStreamType.OFFICIAL;

export const getIsLoadingMore = state => getState(state).isLoadingMore;

export const getIsLoadingStream = state => getState(state).isLoadingStream;

export const isInitialized = state => getState(state).isInitialized;

export const getStream = (state, streamType) =>
  getState(state)[`${streamType}Emotes`];

export const getActiveStream = state => {
  const activeStreamType = getActiveStreamType(state);
  return getStream(state, activeStreamType);
};

export const getSearchQuery = state => getState(state).cachedSearchQuery;
export const getSearchType = state => getState(state).cachedSearchType;
